import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from './app.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {

  title = 'Ecoembes';
  locationPath: string = "";

    constructor(private router: Router, private location: Location, public loaderService: AppService) {
    }

    sUserName: string = "";
    hideHeader: boolean = true;
    
    // Evento OnInit del componente
   ngOnInit(): void {

    }
    
}
